type WindowType = Window & typeof globalThis

export function getTopPitcherWindow(current: WindowType = window): WindowType {
  try {
    if (current.location.protocol === 'file:') {
      return window.top as WindowType
    }
    if (
      current.parent !== current &&
      (current.parent.location.href.includes('pitcher.com') || current.parent.location.href.includes('localhost'))
    ) {
      return getTopPitcherWindow(current.parent as WindowType)
    }
  } catch (e) {
    // Cross-origin hit, stop here
  }
  return current
}
